// PDF download helper for UniFed One exports.
// Fetches binary from authenticated endpoint and triggers a browser download.

import api from './api';

/**
 * Download a PDF export from an authenticated API endpoint.
 * @param {string} path   Path under /api (e.g. "/exports/retirement-projection.pdf")
 * @param {object} params Query string params
 * @param {string} fallbackName Filename fallback if server doesn't supply one
 */
export async function downloadPdf(path, params = {}, fallbackName = 'UniFed_Report.pdf') {
  const res = await api.get(path, {
    params,
    responseType: 'blob',
  });

  // Prefer filename from Content-Disposition
  let filename = fallbackName;
  const cd = res.headers?.['content-disposition'] || res.headers?.get?.('content-disposition');
  if (cd) {
    const m = cd.match(/filename\s*=\s*"?([^";]+)"?/i);
    if (m && m[1]) filename = m[1];
  }

  const blob = new Blob([res.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
